export default ({ fillColor = '#F6F6F6', strokeColor = '#DCDCDC', size = '50px' }) => (
  <svg width={size} height={size} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24.999" cy="24.999" r="23.999" fill={fillColor} stroke={strokeColor} />
    <path d="M24.999 4.59991V10.5999" stroke={strokeColor} /> <path d="M24.999 39.3984V45.3984" stroke={strokeColor} />
    <path d="M35.1992 7.33289L33.3992 10.4506" stroke={strokeColor} />
    <path d="M16.5996 39.5477L14.7996 42.6654" stroke={strokeColor} />
    <path d="M42.666 14.7994L39.5483 16.5994" stroke={strokeColor} />
    <path d="M10.4512 33.3987L7.33348 35.1987" stroke={strokeColor} />
    <path d="M42.666 35.1986L39.5483 33.3986" stroke={strokeColor} />
    <path d="M10.4512 16.5994L7.33348 14.7994" stroke={strokeColor} />
    <path d="M14.7988 7.33289L16.5988 10.4506" stroke={strokeColor} />
    <path d="M33.3984 39.5477L35.1984 42.6654" stroke={strokeColor} />
    <path d="M45.3984 24.999L39.3984 24.999" stroke={strokeColor} />
    <path d="M10.5996 24.999L4.59961 24.999" stroke={strokeColor} />
    <path d="M24.999 13.5995V24.9995L30.999 30.9995" stroke={strokeColor} />
  </svg>
)
